import { pricePerTicketFor, visibleTiers } from '@/lib/pricing';
import { price } from './format';

/**
 * The competition's first bundle tier as an offer, e.g. "10 for £17.91":
 * { qty, total, label }. Null when there's no tier or it isn't cheaper.
 */
export function bundleOffer(c) {
  const tiers = visibleTiers(c?.bulkPricingTiers || []);
  const tier = tiers[0];
  if (!tier?.minQuantity) return null;
  const each = pricePerTicketFor({
    basePrice: c.ticketPrice,
    bulkTiers: c.bulkPricingTiers,
    quantity: tier.minQuantity,
  });
  if (!(each < Number(c.ticketPrice))) return null;
  const total = each * tier.minQuantity;
  return { qty: tier.minQuantity, total, label: `${tier.minQuantity} for ${price(total)}` };
}
